import React, { useEffect, useState } from 'react';
import { customApiDispatch, customApiSelectors } from '@klp/core/api/store';
import { Block } from '@klp/design/Block';
import type { Theme } from '@material-ui/core';
import {
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Snackbar,
} from '@material-ui/core';
import { Remove } from '@material-ui/icons';
import { Alert } from '@material-ui/lab';
import { useSelector } from 'react-redux';
import { useKlpStyles } from '@klp/design/Theme/useKlpStyles';
import { TranslationOrChildren } from '@klp/design/TranslationOrChildren';
import { Link } from '@klp/design/Link';
import { rootStore } from '@forvalter/store';

const styles = (theme: Theme) => ({
    errorList: {
        listStyleType: 'square',
    },
    errorListItem: {
        padding: 0,
        '& > div': {
            minWidth: theme.spacing(4),
        },
    },
});

export const ErrorMessage = () => {
    const { errors } = useSelector(customApiSelectors);
    const [isSnackbarOpen, setIsSnackbarOpen] = useState(false);

    const { clearErrors } = customApiDispatch(rootStore.dispatch);

    const classes = useKlpStyles({}, styles);

    const handleReloadPage = (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();
        window.location.reload();
    };
    const handleClose = () => {
        setIsSnackbarOpen(false);
        clearErrors();
    };

    useEffect(() => {
        if (errors && errors.length > 0) {
            setIsSnackbarOpen(true);
        }
    }, [errors]);

    if (!errors || errors.length === 0) return null;

    return (
        <Block marginBottom="tiny">
            <Snackbar open={isSnackbarOpen} onClose={handleClose}>
                <>
                    <Alert severity="warning" onClose={handleClose}>
                        <TranslationOrChildren translation="general.error.apiError" />
                        <Block marginVertical="compact">
                            <Link
                                href="#"
                                translation="general.error.reloadPage"
                                onClick={handleReloadPage}
                            />
                        </Block>
                        <strong>
                            <TranslationOrChildren
                                translation="general.error.apiErrorTitle"
                                translationOptions={{
                                    count: errors.length,
                                }}
                            />
                        </strong>
                        <List className={classes.errorList}>
                            {errors.map((err) => (
                                <ListItem
                                    key={err.id}
                                    className={classes.errorListItem}
                                >
                                    <ListItemIcon>
                                        <Remove />
                                    </ListItemIcon>
                                    <ListItemText>{err.message}</ListItemText>
                                </ListItem>
                            ))}
                        </List>
                    </Alert>
                </>
            </Snackbar>
        </Block>
    );
};
